export default async function onBoarding({ to, next, store }) {
  const mainSteps = store.getters['onBoardingForm/mainStepCompleted']
  if ((to.name === 'campaigns:create' || to.name === 'campaigns:edit') && !mainSteps) {
    return next({ name: 'campaigns' })
  }
  return next()
}
